<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">
    <!-- Chart1  -->
    <div class="col-lg-5 col-md-12 col-12">
      <div class="card">
        <div class="card-body" *ngIf="isChart">
          <div echarts [options]="chart1Option" class="demo-chart"></div>
        </div>
        <div style="text-align: center;" width="300" height="300" *ngIf="isChart === false">
          <img src="../../../../assets/images/nodatatodisplay.png" alt="nodata" >
        </div>
      </div>
    </div>

    <!-- Card - Your Current Revenue -->
    <div class="col-lg-2 col-md-2 col-12">
      <div class="card">
        <div class="col-xl-12 col-sm-12 xl-50">
          <div class="card text-center pricing-simple">
            <div class="card-body">
              <h4>Current Revenue</h4>
              <h6 class="mb-0">since last payment day</h6>
              <h3></h3>
              <h4 class="f-w-900 inniver-font-revenue-color">{{payout.currentRevenue | currency}}</h4>
              <h6 class="mb-0 f-w-600 bg-dark" ngbTooltip="today" >{{today | date: 'ccc MMM dd, yyyy'}}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chart2  -->
    <div class="col-lg-5 col-md-12 col-12">
      <div class="card">
        <div class="card-body" *ngIf="isChart2">
          <div echarts [options]="chart2Option" class="demo-chart"></div>
        </div>
        <div style="text-align: center;" width="300" height="300" *ngIf="isChart === false">
          <img src="../../../../assets/images/nodatatodisplay.png" alt="nodata" >
        </div>
      </div>
    </div>

    <!-- Card Table - Top Converting Offers -->
    <div class="col-lg-4 col-md-6 col-12">
      <div class="card card-absolute">
        <div class="card-header bg-primary">
          <h5>Your top converting offers</h5>
        </div>
        <div class="card-body custom-datatable">
          <ngx-datatable #table
            class='bootstrap'
            [columnMode]="ColumnMode.flex"
            [headerHeight]="30"
            [rowHeight]="40"
            [limit]="5"
            [rows]="topconverting">
            <ngx-datatable-column name="offerName" [flexGrow]="2">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Offer</span>
              </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <i class="flag-icon flag-icon-{{row.country.alpha2Code | lowercase}}"></i>&nbsp;
                  <a href="pub/offers/{{ row.offerId }}">{{ row.offerName }}</a>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="EPC" [flexGrow]="1">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">EPC</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.epc | currency }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Payout" [flexGrow]="1">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Payout</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.payout | currency }}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
        </div>
      </div>
    </div>

    <!-- Card Tabel - The Newest Offers -->
    <div class="col-lg-4 col-md-6 col-12">
      <div class="card card-absolute">
        <div class="card-header bg-primary">
          <h5>The Newest Offers in system</h5>
        </div>
        <div class="card-body custom-datatable">
          <ngx-datatable #table
              class='bootstrap'
              [columnMode]="ColumnMode.flex"
              [headerHeight]="30"
              [rowHeight]="40"
              [limit]="5"
              [rows]="newest">
              <ngx-datatable-column name="offerName" [flexGrow]="2">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Offer</span>
                </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i class="flag-icon flag-icon-{{row.country.alpha2Code | lowercase}}"></i>&nbsp;
                    <a href="pub/offers/{{ row.offerId }}">{{ row.offerName }}</a>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Payout" [flexGrow]="1">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Payout</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.payout | currency }}
                  </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
      </div>
    </div>

    <div class="col-lg-2 col-md-12 col-12">
      <!-- Card - The month comparison Revenue -->
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-revenue-color">
          <div class="media static-top-widget text-white">
            <div class="align-self-center text-center">
              <app-feather-icons [icon]="'dollar-sign'"></app-feather-icons>
            </div>
            <div class="media-body"><span class="m-0">Revenue</span>
              <h4 class="mt-0 mb-0"><span ngbTooltip="revenue this month">{{mtd_revenue | currency}}</span></h4>
              <h5 class="mt-0 mb-0"><span ngbTooltip="in comparison with last month">{{this.div_revenue | percent}}&nbsp;</span>
                  <i data-feather="trending-up" *ngIf="percent_revenue == true"></i>
                  <i data-feather="trending-down" *ngIf="percent_revenue == false"></i>
              </h5>
              <i class="icon-bg" data-feather="dollar-sign"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Card - The month comparison Clicks -->
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-click-color">
          <div class="media static-top-widget text-white">
            <div class="align-self-center text-center">
              <app-feather-icons [icon]="'activity'"></app-feather-icons>
            </div>
            <div class="media-body"><span class="m-0">Clicks</span>
              <h4 class="mt-0 mb-0"><span ngbTooltip="all cliks this month">{{mtd_clicks}}</span></h4>
              <h5 class="mt-0 mb-0"><span ngbTooltip="in comparison with last month">{{div_clicks | percent}}&nbsp;</span>
                <i data-feather="trending-up" *ngIf="percent_clicks == true"></i><i data-feather="trending-down" *ngIf="percent_clicks == false"></i></h5>
              <i class="icon-bg" data-feather="activity"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Card - The month comparison Conversions -->
    <div class="col-lg-2 col-md-12 col-12">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-conversion-color">
          <div class="media static-top-widget text-white">
            <div class="align-self-center text-center">
              <app-feather-icons [icon]="'shopping-cart'"></app-feather-icons>
            </div>
            <div class="media-body"><span class="m-0">Conversions</span>
              <h4 class="mt-0 mb-0"><span ngbTooltip="all conversions this month">{{mtd_conversions}}</span></h4>
              <h5 class="mt-0 mb-0"><span ngbTooltip="in comparison with last month">{{div_conversions | percent}}&nbsp;</span>
                <i data-feather="trending-up" *ngIf="percent_conversions == true"></i><i data-feather="trending-down" *ngIf="percent_conversions == false"></i></h5>
              <i class="icon-bg" data-feather="shopping-cart"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Card - The month comparison Visitors -->
      <!-- <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-visitor-color">
          <div class="media static-top-widget text-white">
            <div class="align-self-center text-center">
              <app-feather-icons [icon]="'eye'"></app-feather-icons>
            </div>
            <div class="media-body"><span class="m-0">Visitors</span>
              <h4 class="mt-0 mb-0"><span ngbTooltip="all cliks this month">{{mtd_clicks}}</span></h4>
              <h5 class="mt-0 mb-0"><span ngbTooltip="in comparison with last month">{{div_clicks | percent}}&nbsp;</span>
                <i data-feather="trending-up" *ngIf="percent_clicks == true"></i><i data-feather="trending-down" *ngIf="percent_clicks == false"></i></h5>
              <i class="icon-bg" data-feather="eye"></i>
            </div>
          </div>
        </div>
      </div> -->

    </div>


</div>
</div>
<!-- Container-fluid Ends-->
